import styled from 'styled-components';

export const StyledSubTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
`;
